import { call, put, takeLeading, takeLatest, delay } from 'redux-saga/effects'
import {
  types,
  ICreateMediaTypeAction,
  IGetMediaTypeByIdAction,
  IUpdateMediaTypeAction,
  IDeleteMediaTypeAction,
} from '../types/mediaType'
import { Modals } from '../types/modal'
import * as actions from '../actions/mediaType'
import * as mediaTypesActions from '../actions/mediaTypes'
import { push } from '../actions/router'
import { modalOpen } from '../actions/modal'
import * as services from '../services/mediaType'
import { trace } from '../services/common'
import { messages } from '../config/messages'

export function* createMediaTypeSaga(action: ICreateMediaTypeAction) {
  try {
    const mediaTypeData = yield call(
      services.createMediaType,
      action.mediaTypeData
    )
    yield delay(0)
    yield put(
      actions.createMediaTypeSuccess(
        mediaTypeData,
        messages.createMediaTypeCreateSuccess(mediaTypeData.extension)
      )
    )
    yield put(mediaTypesActions.getMediaTypes())
    yield delay(500) // show success message before redirect
    yield put(push('/settings/media-types?tab=all-types'))
  } catch (err) {
    trace(err)
    yield put(actions.createMediaTypeFailure(err.message))
  }
}

export function* getMediaTypeSaga(action: IGetMediaTypeByIdAction) {
  try {
    const mediaTypeData = yield call(
      services.getMediaTypeByExtension,
      action.extension
    )
    yield put(actions.getMediaTypeByIdSuccess(mediaTypeData))
  } catch (err) {
    trace(err)
    if (err.code === 404) {
      yield put(push('/settings/media-types?tab=all-types'))
    }
    yield put(actions.getMediaTypeByIdFailure(err.message))
  }
}

export function* updateMediaTypeSaga(action: IUpdateMediaTypeAction) {
  try {
    const mediaTypeData = yield call(
      services.updateMediaType,
      action.mediaTypeData
    )
    yield put(actions.updateMediaType(mediaTypeData))
    yield put(
      actions.updateMediaTypeSuccess(
        mediaTypeData,
        messages.createMediaTypeUpdateSuccess(mediaTypeData.extension)
      )
    )
    yield put(mediaTypesActions.getMediaTypes())
  } catch (err) {
    trace(err)
    if (err.code === 404) {
      yield put(push('/settings/media-types?tab=all-types'))
    }
    yield put(actions.updateMediaTypeFailure(err.message))
  }
}

export function* deleteMediaTypeSaga(action: IDeleteMediaTypeAction) {
  try {
    yield call(services.deleteMediaType, action.extension)
    yield put(
      actions.deleteMediaTypeSuccess(
        messages.createMediaTypeDeleteSuccess(action.extension)
      )
    )
    yield put(push('/settings/media-types?tab=all-types'))
  } catch (err) {
    trace(err)
    if (err.code === 404) {
      yield put(push('/settings/media-types?tab=all-types'))
    } else {
      yield put(modalOpen(Modals.deleteStatusModal))
    }
    yield put(actions.deleteMediaTypeFailure(err.message))
  }
}

export function* mediaTypeWatcher() {
  yield takeLeading(types.CREATE_MEDIA_TYPE__STARTED, createMediaTypeSaga)
  yield takeLatest(types.GET_MEDIA_TYPE_BY_ID__STARTED, getMediaTypeSaga)
  yield takeLeading(types.UPDATE_MEDIA_TYPE__STARTED, updateMediaTypeSaga)
  yield takeLatest(types.DELETE_MEDIA_TYPE__STARTED, deleteMediaTypeSaga)
}
